import { render, staticRenderFns } from "./orderLogistics.vue?vue&type=template&id=34d1a483&"
import script from "./orderLogistics.vue?vue&type=script&lang=ts&"
export * from "./orderLogistics.vue?vue&type=script&lang=ts&"
import style0 from "./orderLogistics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports